import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-recomendations',
  templateUrl: './payment-recomendations.component.html',
  styleUrls: ['./payment-recomendations.component.scss']
})
export class PaymentRecomendationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
